import { getUserList } from "../../api/list";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {};

export const FetchUsers: any = createAsyncThunk(
  "getUsers/fetchUsers",
  async (params: any, { dispatch, getState }) => {
    const res: any = await getUserList(params);
    const previousUsers:any = getState() || {user:[]};
    if ([1,undefined].includes(res?.result?.page)){
      dispatch(getUsers(res?.result?.data || []));
    } else{
      dispatch(getUsers([...previousUsers.users, ...(res?.result?.data || [])]));
    }
    return res;
  }
);

export const UsersSlice = createSlice({
  name: "Users",
  initialState,
  reducers: {
    getUsers: (state: any, action: PayloadAction<any>) => {
      state = action.payload;
      return state;
    },
  },
});

export default UsersSlice.reducer;
export const { getUsers } = UsersSlice.actions;
